<template>
  <section class="hero-subsection" aria-labelledby="tarifs-hero-title">
    <div class="hero-shell">
      <div class="hero-content">
        <h1 id="tarifs-hero-title" class="hero-title">Des tarifs adaptés à vos besoins</h1>
        <p class="hero-description">
          Choisissez le plan Florisuite qui convient parfaitement à la taille et aux ambitions de votre commerce floral. Commencez votre essai gratuit dès aujourd'hui !
        </p>
        <router-link class="hero-button" to="/inscription">
          <span class="hero-button-text">Démarrer l'essai gratuit</span>
        </router-link>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "HeroSubsection",
});
</script>

<style>
.hero-subsection {
  align-self: stretch;
  background: linear-gradient(135deg, #fafafa 0%, #f7fcf3 100%);
  padding: clamp(52px, 7vw, 96px) clamp(16px, 4vw, 30px) 0;
  width: 100%;
}

.hero-subsection .hero-shell {
  margin: 0 auto;
  max-width: 1200px;
}

.hero-subsection .hero-content {
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: clamp(16px, 2.8vw, 28px);
  margin: 0 auto;
  max-width: 860px;
  text-align: center;
}

.hero-subsection .hero-title {
  color: #171a1f;
  font-family: "Montserrat", Helvetica;
  font-size: clamp(2rem, 5.5vw, 3.5rem);
  font-weight: 700;
  line-height: 1.08;
  margin: 0;
  text-wrap: balance;
}

.hero-subsection .hero-description {
  color: #5f5f5f;
  font-family: "Open Sans", Helvetica;
  font-size: clamp(1rem, 2.1vw, 1.15rem);
  font-weight: 400;
  line-height: 1.6;
  margin: 0;
  max-inline-size: 70ch;
}

.hero-subsection .hero-button {
  align-items: center;
  background-color: #084734;
  border: 1px solid transparent;
  border-radius: 10px;
  box-shadow: 0px 8px 24px rgba(8, 71, 52, 0.14);
  color: #ffffff;
  display: inline-flex;
  justify-content: center;
  min-height: 46px;
  min-width: 240px;
  padding: 10px 22px;
  text-decoration: none;
  transition: transform 0.18s ease, box-shadow 0.18s ease,
    background-color 0.18s ease, border-color 0.18s ease;
}

.hero-subsection .hero-button:hover {
  background-color: #0a5a42;
  box-shadow: 0px 10px 26px rgba(10, 90, 66, 0.2);
  transform: translateY(-1px);
}

.hero-subsection .hero-button:active {
  transform: translateY(0);
}

.hero-subsection .hero-button:focus-visible {
  border-color: rgba(255, 255, 255, 0.75);
  outline: 2px solid rgba(8, 71, 52, 0.35);
  outline-offset: 2px;
}

.hero-subsection .hero-button-text {
  font-family: "Open Sans", Helvetica;
  font-size: 0.95rem;
  font-weight: 700;
  line-height: 1.2;
  text-align: center;
}

@media (max-width: 768px) {
  .hero-subsection {
    padding-top: 48px;
  }

  .hero-subsection .hero-button {
    min-width: 0;
    width: 100%;
  }
}
</style>
